// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProgressBar__Svg {
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

.circular-progress-bar {
  position: relative;
  width: 100px;
  height: 100px;
}

.progress-background {
  stroke: #333;
  stroke-width: 15px;
  /* Background color */
}

.progress {
  transition: stroke-dashoffset 0.5s ease;
}

.percentage {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-weight: bold;
  font-size: 16px;
  color: white;
  /* Color for percentage text */
}

.value {
  font-size: 20px;
  color: black;
  /* Color for the additional value */
}

/* CircularProgressBar.css */
.circular-progress-bar .progress {
  transition: stroke-dashoffset 0.3s ease, box-shadow 0.3s ease;
  /* Add box-shadow transition */
}

.circular-progress-bar .progress.glow {
  animation: glow 1s infinite alternate;
}

@keyframes glow {
  0% {
    stroke-width: 8px;
    box-shadow: 0 0 20px rgba(32, 180, 32, 0.9);
    /* Adjust the shadow properties for the glow effect */
  }
  100% {
    stroke-width: 10px;
    /* Adjust the width for the glow effect */
    box-shadow: 0 0 40px rgba(32, 180, 32, 0.9);
    /* Adjust the shadow properties for the glow effect */
  }
}
.tooltip {
  position: absolute;
  top: 40px;
  /* Adjust the distance above the component */
  left: 50%;
  transform: translateX(-50%);
  background-color: black;
  /* Tooltip background color */
  color: white;
  /* Tooltip text color */
  padding: 5px 10px;
  border-radius: 20px;
  /* Rounded corners to create a capsule-like appearance */
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
  pointer-events: none;
  width: 135px;
  margin-top: 10px;
  /* Add margin between the component and tooltip */
  padding: 5px;
}

.circular-progress-bar:hover .tooltip {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/Components/Common/ProgressBar/ProgressBar.scss"],"names":[],"mappings":"AACI;EACI,gCAAA;EACA,wBAAA;AAAR;;AAIA;EACI,kBAAA;EACA,YAAA;EACA,aAAA;AADJ;;AAIA;EACI,YAAA;EACA,kBAAA;EACA,qBAAA;AADJ;;AAIA;EACI,uCAAA;AADJ;;AAIA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,8BAAA;AADJ;;AAIA;EACI,eAAA;EACA,YAAA;EACA,mCAAA;AADJ;;AAIA,4BAAA;AACA;EACI,6DAAA;EACA,8BAAA;AADJ;;AAIA;EACI,qCAAA;AADJ;;AAIA;EACI;IACI,iBAAA;IACA,2CAAA;IACA,qDAAA;EADN;EAIE;IACI,kBAAA;IACA,yCAAA;IACA,2CAAA;IACA,qDAAA;EAFN;AACF;AAKA;EACI,kBAAA;EACA,SAAA;EACA,4CAAA;EACA,SAAA;EACA,2BAAA;EACA,uBAAA;EACA,6BAAA;EACA,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,wDAAA;EACA,UAAA;EACA,oCAAA;EACA,oBAAA;EACA,YAAA;EACA,gBAAA;EACA,iDAAA;EACA,YAAA;AAHJ;;AAMA;EACI,UAAA;AAHJ","sourcesContent":[".ProgressBar {\n    &__Svg {\n        -webkit-transform: rotate(90deg);\n        transform: rotate(90deg);\n    }\n}\n\n.circular-progress-bar {\n    position: relative;\n    width: 100px;\n    height: 100px;\n}\n\n.progress-background {\n    stroke: #333;\n    stroke-width: 15px;\n    /* Background color */\n}\n\n.progress {\n    transition: stroke-dashoffset 0.5s ease;\n}\n\n.percentage {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    text-align: center;\n    font-weight: bold;\n    font-size: 16px;\n    color: white;\n    /* Color for percentage text */\n}\n\n.value {\n    font-size: 20px;\n    color: black;\n    /* Color for the additional value */\n}\n\n/* CircularProgressBar.css */\n.circular-progress-bar .progress {\n    transition: stroke-dashoffset 0.3s ease, box-shadow 0.3s ease;\n    /* Add box-shadow transition */\n}\n\n.circular-progress-bar .progress.glow {\n    animation: glow 1s infinite alternate;\n}\n\n@keyframes glow {\n    0% {\n        stroke-width: 8px;\n        box-shadow: 0 0 20px rgba(32, 180, 32, 0.9);\n        /* Adjust the shadow properties for the glow effect */\n    }\n\n    100% {\n        stroke-width: 10px;\n        /* Adjust the width for the glow effect */\n        box-shadow: 0 0 40px rgba(32, 180, 32, 0.9);\n        /* Adjust the shadow properties for the glow effect */\n    }\n}\n\n.tooltip {\n    position: absolute;\n    top: 40px;\n    /* Adjust the distance above the component */\n    left: 50%;\n    transform: translateX(-50%);\n    background-color: black;\n    /* Tooltip background color */\n    color: white;\n    /* Tooltip text color */\n    padding: 5px 10px;\n    border-radius: 20px;\n    /* Rounded corners to create a capsule-like appearance */\n    opacity: 0;\n    transition: opacity 0.2s ease-in-out;\n    pointer-events: none;\n    width: 135px;\n    margin-top: 10px;\n    /* Add margin between the component and tooltip */\n    padding: 5px;\n}\n\n.circular-progress-bar:hover .tooltip {\n    opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
